import { AutogenLayoutTerminalCode } from "./autogen/AutogenLayoutTerminalCode";
import { DuplicateId } from "@mcleod/dispatch";

export class TerminalCode extends AutogenLayoutTerminalCode {
    onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "terminal",
            screenName: "Terminal Code",
            navigateToUrl: "lme/settlement/TerminalCode?mode=update&key="
        });
    }
}
